import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";
import { ACTION_DETAILS, ACTION_UPDATE } from "models/role/action";
import { SUBJECT_VX2_ONBOARDING } from "models/role/subject";
import { lazyRetry } from "utils/lazyRetry";

import { PAGE_URLS } from "../constants/PageUrls";

import type { Route } from "routes/RouteModel";

const Onboarding = lazyRetry(
  () => import("../pages/Onboarding"),
  "StablecoinsOnboarding"
);

export const stablecoinsRoutes: Route = {
  path: PAGE_URLS.onboarding,
  title: [COMMON_TRANSLATION_KEYS.stablecoins],
  component: Onboarding,
  can: {
    or: [
      { do: ACTION_UPDATE, on: SUBJECT_VX2_ONBOARDING },
      { do: ACTION_DETAILS, on: SUBJECT_VX2_ONBOARDING },
    ],
  },
};
